import gql from 'graphql-tag'

export const REGISTER = gql`
  mutation createUser (
    $firstname: String
    $lastname: String
    $email: String!
    $phonenumber: String
    $password: String
    $passwordConf: String
  ) {
    createUser(input: {
      firstname: $firstname
      lastname: $lastname
      email: $email
      phonenumber: $phonenumber
      password: $password
      passwordConf: $passwordConf
    }){
        success
        message
    }
  }
`

export const LOGIN = gql`
  mutation login (
    $client_id: String!
    $client_secret: String!
    $grant_type: GrantType!
    $username: String!
    $password: String!
  ) {
    login(input: {
      client_id: $client_id
      client_secret: $client_secret
      grant_type: $grant_type
      username: $username
      password: $password
    }){
        success
        message
        createdAccessToken{
          access_token
          refresh_token
          token_type
          user_id
        }
    }
  }
`

export const CREATE_APPOINTMENT = gql`
  mutation createAppointment (
    $barberId: Int
    $shopId: Int!
    $serviceId: [Int]!
    $start: Date!
    $noPreference: Boolean!
  ) {
    createAppointment (
      input: {
        barberId: $barberId
        shopId: $shopId
        serviceId: $serviceId
        start: $start
        noPreference: $noPreference
      }
    ) {
      success
      message
    }
  }
`

export const CANCEL_APPOINTMENT = gql`
  mutation cancelAppointment (
    $id: Int!
  ) {
    cancelAppointment(input: {
      id: $id
    }){
      success
      message
    }
  }
`

export const UPDATE_PROFILE = gql`
  mutation updateUser (
    $id: Int!
    $firstname: String
    $phonenumber: String
  ) {
    updateUser(input: {
      id: $id
      firstname: $firstname
      phonenumber: $phonenumber
    }){
      success
      message
    }
  }
`

export const REQ_RESET_PASSWORD_TOKEN = gql`
  mutation forgotPassword (
    $email: String!
  ) {
    forgotPassword(input: {
      email: $email
    }) {
      success
      message
    }
  }
`

export const RESET_PASSWORD = gql`
  mutation resetPassword (
    $token: String!
    $password: String!
  ) {
    resetPassword(input: {
      token: $token
      password: $password
    }) {
      success
      message
    }
  }
`



// WEBPACK FOOTER //
// ./src/constants/graphql/mutation.js